export default function forceSelectionByRole (userData, select) {
  const selection = Object.assign({}, select)
  const user = Object.assign({}, userData)
  if (user.role === 'District Admin') {
    if (!selection.district) {
      selection.district = user.schoolDistrict
    }
  } else if (user.role === 'School Admin') {
    if (!selection.district) {
      selection.district = user.schoolDistrict
    }
    if (!selection.school) {
      selection.school = user.school
    }
  } else if (user.role === 'Teacher') {
    if (!selection.district) {
      selection.district = user.schoolDistrict
    }
    if (!selection.school) {
      selection.school = user.school
    }
    if (!selection.teacher) {
      selection.teacher = user.id
    }
  }
  return selection
}


// WEBPACK FOOTER //
// ./src/helpers/users/forceSelectionByRole.js